function getEnvironment(): 'production' | 'staging' | 'dev' {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname || '';
    if (hostname.includes('staging')) {
      return 'staging';
    }
    if (hostname.includes('vaa.vantis-praxis.de')) {
      return 'production';
    }
  }

  // Fall back to build mode (for Electron location is app://index.html)
  const mode = import.meta.env.MODE;
  if (mode === 'production') {
    return 'production';
  }
  if (mode === 'staging') {
    return 'staging';
  }
  if (mode === 'dev') {
    return 'dev';
  }
  return 'staging';
}

export const environment = getEnvironment();

export const isElectron = typeof window !== 'undefined' && !!window.electronAPI;

declare global {
  interface Window {
    environment: typeof environment;
  }
}

if (typeof window !== 'undefined') {
  window.environment = environment;
}

export function getEnvVar(key: string, fallback?: string): string | undefined {
  const rawValue = (import.meta.env as Record<string, unknown>)[key];
  if (typeof rawValue === 'string') {
    const trimmedValue = rawValue.trim();
    if (trimmedValue.length > 0) {
      return trimmedValue;
    }
  }
  return fallback;
}
